<h2 mat-dialog-title>
  {{ 'FRONTEND.SALES_UI.OPPORTUNITY_TAGS.ADD_DIALOG.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <glxy-form-field>
    <glxy-label>
      {{ 'FRONTEND.SALES_UI.OPPORTUNITY_TAGS.ADD_DIALOG.LABEL' | translate }}
    </glxy-label>
    <glxy-tags-input
      [formControl]="tagsControl"
      [availableTags]="filteredTags"
      (searchText)="searchTextChanged($event)"
    />
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-flat-button type="submit" color="primary" (click)="save()">
    {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
